export default {
  siteName: '郝海东官方介绍站',
  navHome: '首页',
  navGoals: '进球纪录',
  navNationalTeam: '国家队生涯',
  navDalian: '大连实德',
  navControversy: '争议事件',
  navProfile: '个人资料',
  navAbout: '关于本站',
  footerDescription: '全面呈现中国足球传奇前锋郝海东的球员生涯、进球纪录、国家队荣耀与历史地位。',
  footerQuickLinks: '快速链接',
  footerContact: '联系方式',
  footerCopyright: '郝海东官方介绍站 版权所有',
  breadcrumbHome: '首页',
  backToHome: '返回首页',
  allArticles: '全部文章',
  readArticle: '阅读文章',
  noArticles: '暂无相关文章',
  backToCategories: '返回分类',
  relatedArticles: '相关文章',
  publishedOn: '发布于',
  readTime: '阅读时间',
  backToList: '返回列表',
  pageTitle: '关于本站',
  brandIntro: '品牌介绍',
  reputation: '声誉声明',
  contactUs: '联系我们',
  contactIntro: '如果您有任何关于郝海东的资料、建议或合作意向，欢迎通过以下表单与我们联系。',
  formName: '姓名',
  formNamePlaceholder: '请输入您的姓名',
  formEmail: '邮箱',
  formEmailPlaceholder: '请输入您的邮箱地址',
  formSubject: '主题',
  formSubjectPlaceholder: '请选择主题',
  formMessage: '留言内容',
  formMessagePlaceholder: '请输入您的留言内容（不超过500字）',
  formSubmit: '提交留言',
  formSubmitting: '提交中...',
  formSuccess: '感谢您的留言！我们会尽快回复。',
  formError: '提交失败，请稍后重试。',
  subjectGeneral: '一般咨询',
  subjectData: '资料提供',
  subjectCooperation: '合作意向',
  subjectOther: '其他',
};